import { ArrowLeft } from 'lucide-react';
import type { ReactNode } from 'react';

import { cn } from '@shared/lib/utils';
import { Button, type ButtonProps } from '../primitives/button';

type PageBackLinkProps = ButtonProps & {
  children: ReactNode;
};

export function PageBackLink({
  children,
  className,
  variant,
  size,
  asChild,
  ...props
}: PageBackLinkProps) {
  return (
    <Button
      asChild={asChild}
      variant={variant ?? 'ghost'}
      size={size ?? 'sm'}
      className={cn('h-auto w-fit px-0 py-0', className)}
      {...props}
    >
      <ArrowLeft className="h-4 w-4" aria-hidden="true" />
      {children}
    </Button>
  );
}
